import { useTheme } from "@mui/material";
import { useAtomValue } from "jotai";
import { bottomBarSpacingOverrideAtom } from "web_myplann/Shared/State/bottomBarSpacingOverrideAtom";

/**
 * Bottom spacing the content must reserve for the native bottom bar. The value is
 * driven solely by the `--mobile-bottom-inset` variable injected by the native shell
 * (single source of truth) — deciding by the `pilotGoal` right here as well allowed
 * the two sides to disagree (native legacy bar + web floating-bar padding), which
 * showed up as dead space above the bottom bar.
 */
export const useBottomBarSpacing = () => {
	const theme = useTheme();
	const override = useAtomValue(bottomBarSpacingOverrideAtom);

	return override ?? theme.bottomSpacing.nativeBottomBar;
};
